<template>
    <footer class="site-footer container mt-auto">
        <div class="row position-relative">
            <div class="col">
                <p class="text-center small py-3 mb-0">
                    <span class="site-footer__copyright ml-2 mr-2 text-gray-600 mx-2 text-nowrap">Copyright © 2022 - {{year}} Tapgiant</span>
                    <router-link v-if="marketingRoute" :to="{ name: 'store_provisioning' }" class="site-footer__link mx-2">
                        {{$t('footer.store_provisioning')}}
                    </router-link>
                    <router-link v-if="marketingRoute" :to="{ name: 'push_notifications' }" class="site-footer__link mx-2">
                        {{$t('footer.push_notifications')}}
                    </router-link>
                    <router-link v-if="marketingRoute" :to="{ name: 'push_notifications_android' }" class="site-footer__link mx-2">
                        {{$t('footer.push_notifications_android')}}
                    </router-link>
                    <router-link :to="{ name: 'contact' }" class="site-footer__link mx-2" exact>
                        {{$t('footer.contact')}}
                    </router-link>
                    <router-link :to="{ name: 'terms' }" class="site-footer__link mx-2" exact>
                        {{$t('footer.terms_conditions')}}
                    </router-link>
                    <router-link :to="{ name: 'privacy' }" class="site-footer__link mx-2" exact>
                        {{$t('footer.privacy_policy')}}
                    </router-link>
                    <router-link :to="{ name: 'legal' }" class="site-footer__link mx-2" exact>
                        {{$t('footer.legal_entity')}}
                    </router-link>
                    <span class="dropdown d-inline-block mx-2">
                        <a class="nav-link dropdown-toggle me-4" href="#" id="dropdown03" data-bs-toggle="dropdown" aria-expanded="false">
                            <span v-if="locale === 'ro'">
                                <img src="/img/flag/ro.png" class="me-2">
                                <span class="align-middle">RO</span>
                            </span>
                            <span v-if="locale === 'en'" class="d-inline-block align-middle">
                                <img src="/img/flag/us.png" class="me-2">
                                <span class="align-middle">EN</span>
                            </span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="dropdown03">
                            <li><span v-if="locale !== 'ro'" @click="set_locale('ro')" class="pe-pointer mx-2 py-2 d-block"><img src="/img/flag/ro.png" class="me-2"><span class="align-middle">RO</span></span></li>
                            <li><span v-if="locale !== 'en'" @click="set_locale('en')" class="pe-pointer mx-2 py-2 d-block"><img src="/img/flag/us.png" class="me-2"><span class="align-middle">EN</span></span></li>
                        </ul>
                    </span>
                </p>
            </div>
        </div>
        <vue-cookie-accept-decline :debug="false" :disableDecline="true" :showPostponeButton="false"
                                   @clicked-accept="cookieClickedAccept"
                                   @clicked-decline="cookieClickedDecline"
                                   @clicked-postpone="cookieClickedPostpone"
                                   @removed-cookie="cookieRemovedCookie"
                                   @status="cookieStatus"
                                   elementId="cookie-banner"
                                   position="bottom-right"
                                   ref="cookie-banner"
                                   transitionName="slideFromBottom"
                                   type="floating">
            <!-- Optional -->
            <template #message>
                <p class="fw-bolder m-0">{{$t('marketing.cookies.title')}}</p>
                <div>{{$t('marketing.cookies.intro')}}</div>
                <hr>
                <div>
                    <!-- Necessary Cookies -->
                    <div class="bg-white rounded px-3 py-3">
                        <div class="d-flex align-items-center">
                            <div class="flex-fill fw-bolder">
                                {{$t('marketing.cookies.necessary')}}
                            </div>
                            <div class="form-check form-switch">
                                <input v-model="cookies.necessary" class="form-check-input fs-3 pe-pointer m-0" type="checkbox" id="flexSwitchCheckChecked" disabled>
                            </div>
                        </div>
                        <div class="mt-2">{{$t('marketing.cookies.necessary_description')}}</div>
                    </div>
                    <hr>
                    <!-- Preferences Cookies -->
                    <div class="bg-white rounded px-3 py-3">
                        <div class="d-flex align-items-center">
                            <div class="flex-fill fw-bolder">
                                {{$t('marketing.cookies.preferences')}}
                            </div>
                            <div class="form-check form-switch">
                                <input v-model="cookies.preferences" class="form-check-input fs-3 pe-pointer m-0" type="checkbox" id="flexSwitchCheckChecked">
                            </div>
                        </div>
                        <div>{{$t('marketing.cookies.preferences_description')}}</div>
                    </div>
                </div>
                <hr>
                <div>
                    <p class="m-0">{{$t('marketing.cookies.domains')}}</p>
                    <ul>
                        <li><a :href="'https://www.' + TLD" target="_blank" rel="noopener">www.{{TLD}}</a></li>
                        <li><a :href="'https://store.' + TLD" target="_blank" rel="noopener">store.{{TLD}}</a></li>
                    </ul>
                </div>
                <p class="m-0">{{$t('marketing.cookies.learn_more')}}</p>
            </template>

            <template #acceptContent>{{$t('marketing.cookies.allow')}}</template>
        </vue-cookie-accept-decline>
    </footer>
</template>

<script>
import {
    COOKIE_CONSENT_NECESSARY,
    COOKIE_CONSENT_PREFERENCES,
    TLD
} from '@/common/constants'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import {
    getPublicOrigin,
    getPublicPath,
    isTapgiantPublicDomain
} from '@/pages/home/public-routes.js'

export default {
    components: {
        VueCookieAcceptDecline
    },
    props: {
        marketing: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            COOKIE_CONSENT_NECESSARY,
            COOKIE_CONSENT_PREFERENCES,
            TLD,
            cookieStatus: '',
            cookies: {
                necessary: true,
                preferences: true
            }
        }
    },
    computed: {
        year: () => new Date().getFullYear(),
        locale: function () {
            return this.$i18n.locale
        },
        marketingRoute: function () {
            return this.marketing && Boolean(getPublicPath(this.$route.name, this.locale))
        }
    },
    methods: {
        set_locale: function (locale) {
            const targetPath = this.marketing ? getPublicPath(this.$route.name, locale) : null

            if (targetPath && isTapgiantPublicDomain()) {
                window.location.assign(`${getPublicOrigin(locale)}${targetPath}${this.$route.hash || ''}`)
                return
            }

            this.$bus.$emit('App/locale', locale)
        },
        cookieClickedAccept: function () {
            this.$store.commit('SET_COOKIE_CONSENT', {
                cookie_name: COOKIE_CONSENT_NECESSARY,
                cookie_value: this.cookies.necessary ? '1' : '0'
            })
            this.$store.commit('SET_COOKIE_CONSENT', {
                cookie_name: COOKIE_CONSENT_PREFERENCES,
                cookie_value: this.cookies.preferences ? '1' : '0'
            })
        },
        cookieClickedDecline: function () {},
        cookieClickedPostpone: function () {},
        cookieRemovedCookie: function () {}
    }
}
</script>
